module.exports = __webpack_public_path__ + "img/logo.a1a1ac18.gif";